<template>
  <div class="object-dashboard">
    <!-- Sub Navbar -->
    <v-app-bar
        app
        clipped-right
        class="mt-16 sub-app-bar"
        fixed
    >
      <v-row align="center">
        <v-col cols="1" md="4" lg="3">
          <div class="d-flex flex-row">
            <div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs}">
                  <v-btn icon @click="$router.push($store.state.settings.routes.lastMainRoute)" v-bind="attrs" v-on="on">
                    <v-icon>arrow_back_ios</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('buttons:back') }}</span>
              </v-tooltip>
            </div>
            <div v-if="$vuetify.breakpoint.smAndUp">
              <p class="title">
                {{ $t('common:settings') }}
              </p>
              <p class="subtitle">{{ $t('settings/profile:common.profile') }}</p>
            </div>
          </div>
        </v-col>
        <v-spacer></v-spacer>
        <v-col class="text-right d-none d-sm-flex">
          <p class="mb-0 pb-0 grey--text ml-auto">
            <v-icon color="grey">calendar_today</v-icon>
            {{ currentDate }}
          </p>
        </v-col>
      </v-row>
    </v-app-bar>
    <router-view class="px-5 py-10" ref="routerView" :key="refreshRouterKey"></router-view>

    <!-- QuicklinkSidebar -->
    <ProfileQuickLinkSidebar @addUser="addUser" @refreshRouter="refreshRouter"/>

  </div>
</template>
<script>

import ProfileQuickLinkSidebar from './ProfileQuickLinkSidebar'
import DateUtils from "@/modules/core/services/date-utils";

export default {
  name: 'ProfilePage',
  components: {
    ProfileQuickLinkSidebar
  },
  data() {
    return {
      currentDate: null,
      refreshRouterKey: 1,
    }
  },
  methods: {
    // addUser when current page is already customer users page
    addUser() {
      // get the usersDialogForm and run addUser method with stored pagiantion options and search
      this.$refs.routerView.$children[0].$refs.usersDialogForm.addUser(
        this.$store.state.settings.userProfile.overview.options,
        this.$store.state.settings.userProfile.overview.search
      )
    },
    refreshRouter() {
      this.refreshRouterKey++;
    }
  },
  // store last main route to route back when clicked arrow in sub-bar
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if(from.path !== "/" + vm.$store.state.manager.settingsModuleUrl + "/profile/user") {
        vm.$store.commit(vm.$store.state.manager.settingsModuleUrl + '/routes/storeLastMainRoute', from)
      }
    })
  },
  created() {
    // get current date as DE format
    this.currentDate = DateUtils.getCurrentDateAsDEString();
  }
}
</script>